import { useForm } from 'react-hook-form'

import { rotasApiAutenticadoV5 } from '../../../configurações/rotasApi/rotasApiAutenticadoV5'

import { AlunoModel } from '@/@types/Models'
import { api } from '@/api/api'
import {
  responseError,
  responseSuccess,
} from '@/utilitários/handler/responseHandler'
import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { z } from 'zod'

const { path } = rotasApiAutenticadoV5.completarVerificacao

export const useCadastroWithGoogle = () => {
  const {
    mutate: cadastroAlunoWithgoogle,
    isLoading: cadastroAlunoWithgoogleIsLoading,
    status: cadastroAlunoWithgoogleStatus,
  } = useMutation(endPoint, {
    onSuccess: () => {
      responseSuccess('Cadastro realizado')
    },
    onError: (erro: AxiosError) => responseError(erro),
  })

  const cadastroAlunoWithgoogleContext =
    useForm<CadastroAlunoWithgoogleContextSchema>({
      resolver: zodResolver(cadastroAlunoWithgoogleContextSchema),
      reValidateMode: 'onSubmit',
    })

  return {
    cadastroAlunoWithgoogle,
    cadastroAlunoWithgoogleContext,
    cadastroAlunoWithgoogleIsLoading,
    cadastroAlunoWithgoogleStatus,
  }
}

async function endPoint(
  dataNew: CadastroAlunoWithgoogleContextSchema,
): Promise<AlunoModel> {
  const data = {
    matricula: dataNew.matricula,
    instituicaoId: dataNew.instituicaoId,
  }
  const headers = {
    'google-id-token': dataNew.tokenGoogleId,
  }
  const result = await api().post(path, data, { headers })
  return result.data.data
}

export const cadastroAlunoWithgoogleContextSchema = z.object({
  matricula: z.string().min(1),
  instituicaoId: z.string().min(1),
  tokenGoogleId: z.string().optional().nullable(),
})

export type CadastroAlunoWithgoogleContextSchema = z.infer<
  typeof cadastroAlunoWithgoogleContextSchema
>
